import { HttpClient } from '../HttpClient';

/**
 * Get Loan Ranges
 * @returns {Promise<any>}
 */

export const GetLoanRanges = async () => {
  try {
    const response = await HttpClient.get('/api/v1/loans/ranges');
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};
